module.exports = __webpack_public_path__ + "static/media/green-circle.e75b0dc1.svg";